<template>
	<router-view />
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style>
	.demo-table-expand {
		display: flex;
		flex-wrap: wrap;
		font-size: 0;
	}

	.demo-table-expand label {
		width: auto;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 45%;
	}
</style>
